<template>
  <div>
    <b-form-group :label="label">
      <validation-provider
        #default="{ errors }"
        :rules="{required: require_}"
        name="Pessoa"
      >
        <multiselect
          ref="pessoaMultiselect"
          v-model="value_"
          :options="pessoas"
          label="nome"
          placeholder=""
          track-by="id"
          class="pessoa-multiselect"
          :multiple="multiple"
          :disabled="disabled"
          :close-on-select="false"
          :limit="limit"
          :limit-text="limitText"
          :select-label="''"
          :deselect-label="''"
          :selected-label="''"
          :loading="pessoasLoading"
          :internal-search="false"
          @close="onTouch"
          @open="carregarPessoas"
          @search-change="carregarPessoasFiltradas"
          @input="enviarParaPai"
        >
          <template slot="noResult">
            <span>Nenhum resultado encontrado</span>
          </template>
          <template slot="noOptions">
            <span>Nenhuma Pessoa cadastrada</span>
          </template>
          <template slot="limit">
            <strong
              v-if="value_"
              id="pessoasSelecionadas"
              class="multiselect__strong"
            >{{ `+ ${value_.length - limit}` }}</strong>
            <b-popover
              id="pessoasPopover"
              :placement="'bottom'"
              :target="'pessoasSelecionadas'"
              triggers="hover"
              class="pessoa-multiselect-popover"
              @show="showPopover($event)"
            >
              <div slot="title">
                <span
                  class="text-center"
                  style="vertical-align: sub"
                >Pessoas selecionadas</span>
              </div>
              <div
                v-for="(pessoa, i) in value_"
                :key="i"
              >
                <b-row>
                  <b-col cols="12">
                    <span>{{ `${pessoa.nome}` }}</span>
                    <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
                  </b-col>
                </b-row>
              </div>
            </b-popover>
          </template>
        </multiselect>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<style lang="scss">
.pessoa-multiselect {
  background: none;
  border-radius: 0.357rem;

  & .multiselect__content {
    display: block !important;
  }

  & .multiselect__element {
    font-size: 0.9rem;
  }

  & .multiselect__strong {
    right: 26px !important;
  }

  & .multiselect__tags {
    padding-right: 0px !important;
    max-height: auto !important;
  }

  & .multiselect__tag {
    white-space: nowrap !important;
    overflow: hidden !important;
    max-width: calc(23em - 25px);
    text-overflow: ellipsis !important;
    background: var(--primary) !important;
    border-radius: 3px !important;
    span {
      font-size: 0.9rem;
    }
  }

  & .multiselect__option {
    & svg {
      display: none;
    }
  }

  & .multiselect__option--selected {
    background: var(--primary) !important;
    color: #ffffff !important;
    font-weight: normal;
    & .company-identification span {
      color: #ffffff !important;
      background-color: transparent;
      border: 1px solid #ffffff !important;
    }
    & svg {
      display: inline;
    }
  }

  & .multiselect__option--highlight {
    background: rgba(var(--primary-rgb), 0.1);
    color: var(--primary);
  }

  & .multiselect__strong {
    color: var(--primary);
    cursor: pointer;
  }

  & .multiselect__tag-icon::after {
    color: #a6eda06e;
    font-size: 1.7rem;
  }

  & .multiselect__tag-icon:hover {
    background: none;
  }
}

.pessoa-multiselect-popover .popover-body {
  height: 360px;
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-wrap;
}
</style>

<script>
/* eslint-disable no-underscore-dangle */
import {
  required,
} from '@validations'
import { ValidationProvider } from 'vee-validate'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import api from '@/app-modulo/comercial/pessoa/shared/services/api'

export default {
  name: 'PessoaMultiselect',
  components: {
    Multiselect,
    ValidationProvider,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [Object, Array],
      default: () => {},
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
    label: {
      type: String,
      default: 'Pessoa',
    },
    multiselect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      valueAttr: null,
      foiAcessado: false,
      pessoas: [],
      primeiroAcesso: true,
      filtros: [
        {
          colunas: ['nome'],
          valor: null,
        },
      ],
      pessoasCarregadas: [],
      limit: 3,
      pessoasLoading: false,
      timer: null,
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(value) {
        this.valueAttr = value
      },
    },
    isInvalid() {
      return this.invalid && this.foiAcessado
    },
    require_: {
      get() {
        return this.require
      },
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.value_ = val
      }
    },
  },
  mounted() {
    if (this.$refs.pessoaMultiselect) {
      const element = this.$refs.pessoaMultiselect.$el.offsetWidth
      this.limit = Math.trunc(element / 180)
    }
  },
  methods: {
    showPopover(e) {
      const el = document.getElementsByClassName('multiselect pessoa-multiselect multiselect--active')
      if (el.length === 1) {
        e.preventDefault()
      }
    },
    limitText(count) {
      return `+${count}`
    },
    carregarPessoas() {
      const el = document.getElementById('pessoasPopover')
      if (el) {
        this.$refs.pessoaMultiselect.isOpen = false
      } else if (!el) {
        if (this.primeiroAcesso) {
          this.pessoasLoading = true
          api.getPessoasResumidas(this.filtros)
            .then(payload => {
              this.pessoasCarregadas = payload.data
              this.setItensCarregados(payload.data)
              this.primeiroAcesso = false
              this.pessoasLoading = false
              this.$refs.pessoaMultiselect.isOpen = true
            })
            .catch(err => {
              this.pessoasLoading = false
              this.$errorFormated(err.response)
              throw err
            })
        } else {
          this.pessoas = [...this.pessoasCarregadas]
          this.setItensCarregados(this.pessoas)
          this.$refs.pessoaMultiselect.isOpen = true
        }
      }
    },
    carregarPessoasFiltradas(value) {
      if (this.timer) {
        clearTimeout(this.timer)
      }

      this.timer = setTimeout(() => {
        this.filtros[0].valor = value
        this.pessoasLoading = true
        api.getPessoasResumidas(this.filtros)
          .then(payload => {
            this.setItensCarregados(payload.data)
            this.pessoasLoading = false
          })
          .catch(err => {
            this.pessoasLoading = false
            this.$errorFormated(err.response)
            throw err
          })
      }, 2000)
    },
    setItensCarregados(itensCarregados) {
      const itensFiltroAdicional = this.filtroAdicional(itensCarregados)
      this.pessoas = itensFiltroAdicional !== null ? itensFiltroAdicional : itensCarregados
    },
    enviarParaPai() {
      this.$emit('select', !this.value_ ? null : this.value_)
      this.$emit('input', !this.value_ ? null : this.value_)
    },
    onTouch() {
      this.foiAcessado = true
    },
  },
}
</script>
